import { ActionIcon, Indicator } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Text from 'components/shared/Text';
import { userNotificationsStore } from 'stores/global/RootStore';

type UserNotificationsButtonProps = {
  className?: string;
  colorIcon?: string;
};

const UserNotificationsButton: React.FC<UserNotificationsButtonProps> = ({ className, colorIcon }) => {
  const { modal, unReadCount } = userNotificationsStore;

  return (
    <Indicator
      disabled={!unReadCount.value}
      className={className}
      size="18"
      label={
        <Text size="xs" fw="600">
          {unReadCount.value}
        </Text>
      }
    >
      <ActionIcon onClick={modal.open} size={36} variant="light">
        <IconBell size={24} color={colorIcon} />
      </ActionIcon>
    </Indicator>
  );
};

export default observer(UserNotificationsButton);
